import React from 'react';
import { observer } from 'mobx-react';
import { UserProfile as DescopeUserProfile, useUser } from '@descope/react-sdk';

import { UserProfileHeader } from './components/header';
import { Loader } from 'common/components/branch-plus-policy/loader';
import useSession from 'core/hooks/use-session';
import { signOut } from '../auth';
import useStyles from './user-profile.styles';

// @TODO: Remove this once Descope supports CSP nonce for user profile widget
const nonce = document.querySelector('meta[property="csp-nonce"]')?.getAttribute('content');
window.DESCOPE_NONCE = nonce;

const UserProfile = () => {
  const classes = useStyles();
  const { user, isUserLoading } = useUser();
  const { loading: isSessionLoading } = useSession();

  const isLoading = isUserLoading || isSessionLoading;

  return (
    <>
      <UserProfileHeader />
      {isLoading ? (
        <Loader />
      ) : (
        <DescopeUserProfile
          widgetId="user-profile-widget"
          tenant={user?.userTenants?.[0]?.tenantId}
          onLogout={async () => {
            await signOut();
          }}
        />
      )}
      <div className={classes.footerWrapper} />
    </>
  );
};

export default observer(UserProfile);
